import Ajaxinate from 'ajaxinate';
import AOS from 'aos';

const selectors = {
  ajaxinateContainer: '#AjaxinateLoop',
  ajaxinatePagination: '#AjaxinatePagination',
};

let sections = {};

class Ajaxify {
  constructor(container) {
    this.container = container;
    this.endlessScroll = null;

    if (theme.settings.enableInfinityScroll) {
      this.init();
    }
  }

  init() {
    this.loadMoreFix();
    this.endlessScroll = new Ajaxinate({
      container: selectors.ajaxinateContainer,
      pagination: selectors.ajaxinatePagination,
      method: 'scroll',
      callback: () => {
        AOS.refreshHard();
      },
    });
  }

  loadMoreFix() {
    // Fix ajaxinate in theme editor
    Ajaxinate.prototype.loadMore = function loadMore() {
      this.request = new XMLHttpRequest();

      this.request.onreadystatechange = function success() {
        if (!this.request.responseXML) {
          return;
        }
        if (!this.request.readyState === 4 || !this.request.status === 200) {
          return;
        }

        const newContainer = this.request.responseXML.querySelector(this.settings.container);
        const newPagination = this.request.responseXML.querySelector(this.settings.pagination);

        this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

        if (typeof newPagination === 'undefined' || newPagination === null) {
          this.removePaginationElement();
        } else {
          this.paginationElement.innerHTML = newPagination.innerHTML;

          if (this.settings.callback && typeof this.settings.callback === 'function') {
            this.settings.callback(this.request.responseXML);
          }

          this.initialize();
        }
      }.bind(this);

      this.request.open('GET', this.nextPageUrl, true);
      this.request.responseType = 'document';
      this.request.send();
    };
  }

  unload() {
    if (this.endlessScroll) {
      this.endlessScroll.destroy();
    }
  }
}

const ajaxify = {
  onLoad() {
    sections = new Ajaxify(this.container);
  },
  onUnload: function () {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

export {ajaxify, Ajaxify};
